import { Injectable } from "@angular/core";
import { HttpClient} from '@angular/common/http';
import { HttpClientBase } from "./http-client-base.service";

@Injectable({ providedIn: 'root' })
export class FilesService extends HttpClientBase {

    constructor(http: HttpClient) {
        super(http, 'files');
    }

    get headers() {

        return {

            headers: {
            }
        }

    }

    verImagenFirma( url: string, params) {
                
        return this.get<{data: any}>({ endpoint: `${url}`, params })
    }


    

    


}